export const EMPTY_URL_GROUP: string = 'Не указана ссылка на группу';
export const EMPTY_ID_FILE: string = 'Файл c id не загружен или пустой';
export const EMPTY_URL_GROUP_LIST: string = 'Не указаны ссылки на группы';
export const EMPTY_LINKS_LIST: string = 'Не указаны ссылки';
